/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";

import {triggerToast} from "helpers";

import HeroBanner from "./HeroBanner";

const propTypes = {
  partnerData: PropTypes.object,
  rCode: PropTypes.string,
  resetPin: PropTypes.bool
};

const HeroBannerContainer = ({
  rCode,
  partnerData,
  resetPin
}) => {
  const [toggleModal, setToggleModal] = useState(false);

  useEffect(() => {
    if (resetPin) {
      setToggleModal(true);
      triggerToast("Login to setup new pin.", "success");
    }
  }, []);

  return (
    <HeroBanner
      partnerData={partnerData}
      rCode={rCode}
      resetPin={resetPin}
      setToggleModal={setToggleModal}
      toggleModal={toggleModal}
    />
  );
};

HeroBannerContainer.propTypes = propTypes;

export default HeroBannerContainer;
